module.exports = __webpack_public_path__ + "static/assets/019003f71649e81b41458bcbbef639db.jpg";